module.exports = __webpack_public_path__ + "static/commerce-50e2876d7c396ede230657da6e00896a.png";